import { Controller } from "@hotwired/stimulus";
import * as Turbo from "@hotwired/turbo";

export default class extends Controller {
  static targets = ["searchInput", "selectedItem", "dropdown", "item"];
  static values = { submitUrl: String, paramName: String };

  connect() {
    this.boundHandleClickOutside = this.handleClickOutside.bind(this);
    document.addEventListener("click", this.boundHandleClickOutside);
  }

  disconnect() {
    document.removeEventListener("click", this.boundHandleClickOutside);
  }

  update(event) {
    event.preventDefault();
    const button = event.currentTarget;
    const label = button.querySelector(".item-label").textContent.trim();
    const value = button.querySelector(".item-value").textContent.trim();
    
    this.searchInputTarget.value = label;
    this.selectedItemTarget.value = value;
    
    this.hideDropdown();
    
    if (this.hasSubmitUrlValue && this.submitUrlValue) {
      this.submitSelection(value);
    }
  }

  submitSelection(value) {
    const csrfToken = document.querySelector("meta[name='csrf-token']").content;
    const paramName = this.hasParamNameValue ? this.paramNameValue : "value";
    const bodyData = {};
    bodyData[paramName] = value;
    
    fetch(this.submitUrlValue, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-Token": csrfToken,
        "Accept": "text/vnd.turbo-stream.html"
      },
      body: JSON.stringify(bodyData)
    })
    .then(response => response.text().then(html => ({ html, ok: response.ok })))
    .then(({ html, ok }) => {
      Turbo.renderStreamMessage(html);
      if (ok) {
        this.searchInputTarget.value = "";
        this.selectedItemTarget.value = "";
      }
    })
    .catch(error => {
      console.error("Error submitting selection:", error);
    });
  }

  filter(event) {
    const searchTerm = event.target.value.toLowerCase().trim();
    
    if (searchTerm === "") {
      this.hideDropdown();
      this.selectedItemTarget.value = "";
      return;
    }
    
    let visibleCount = 0;
    
    this.itemTargets.forEach((item) => {
      const label = item.querySelector(".item-label").textContent.toLowerCase();
      const matches = label.includes(searchTerm);
      
      item.style.display = matches ? "" : "none";
      if (matches) visibleCount++;
    });
    
    if (visibleCount > 0) {
      this.showDropdown();
    } else {
      this.hideDropdown();
    }
  }
  
  showDropdown() {
    this.dropdownTarget.style.display = "block";
    this.searchInputTarget.setAttribute("aria-expanded", "true");
  }
  
  hideDropdown() {
    this.dropdownTarget.style.display = "none";
    this.searchInputTarget.setAttribute("aria-expanded", "false");
  }
  
  handleClickOutside(event) {
    if (!this.element.contains(event.target)) {
      this.hideDropdown();
    }
  }
}
